// index.js
import './polyfills/cryptoRandomUUID';
import React from 'react';
import ReactDOM from 'react-dom/client';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import App from './App';
import reportWebVitals from './reportWebVitals';
import createAppTheme from './theme';
import { ThemeModeProvider, useThemeMode } from './themeMode';
import './index.css';
import { initializeLogging, logDebug } from './logging/loggingService';

import { ThemeProvider, CssBaseline } from '@mui/material';
import { DevSupport } from '@react-buddy/ide-toolbox';
import { ComponentPreviews, useInitial } from './dev';

initializeLogging();
dayjs.locale('de');
document.documentElement.setAttribute('lang', 'de');

function ThemeRoot() {
    const { mode } = useThemeMode();
    const theme = React.useMemo(() => createAppTheme(mode), [mode]);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <DevSupport ComponentPreviews={ComponentPreviews} useInitialHook={useInitial}>
                <App />
            </DevSupport>
        </ThemeProvider>
    );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ThemeModeProvider>
            <ThemeRoot />
        </ThemeModeProvider>
    </React.StrictMode>
);

reportWebVitals((metric) => {
    logDebug('Web vital metric captured', {
        component: 'performance',
        metric,
    });
});
